export const aiModels = [
  'GPT_6_ASTRA',
  'GPT_6_1_SOL',
  'GPT_6_1_TERRA',
  'GPT_6_SOL',
  'GPT_6_LUNA',
  'GPT_5_6_SOL',
  'GPT_5_6_TERRA',
  'GPT_5_6_LUNA',
  'GPT_5_5_PRO',
  'GPT_5_5',
  'GPT_5_4_PRO',
  'GPT_5_4',
  'GPT_5_4_MINI',
  'GPT_5_4_NANO',
  'GPT_5_2_PRO',
  'GPT_5_2',
  'GPT_5_1',
  'GPT_5_PRO',
  'GPT_5_MINI',
  'GPT_5_NANO',
  'GPT_5',
  'GPT_4_1_MINI',
  'GPT_O_4_MINI',
  'GPT_4_O_MINI',
  'GPT_O_3',
  'SONAR_PRO',
  'SONAR_REASONING_PRO',
  'SONAR_DEEP_RESEARCH',
  'SONAR',
  'N8N',
  'QWEN3_6_27B',
  'DEEPSEEK_R1_32B',
  'LLAMA3_LATEST',
  'GEMMA4_26B',
  'QWEN2_5_CODER_14B_INSTRUCT',
  'GEMMA3_27B',
  'CLAUDE_SONNET_4_6',
  'CLAUDE_SONNET_4_5',
  'CLAUDE_HAIKU_4_5',
  'CLAUDE_OPUS_4_8',
  'MINIMAX_M3',
  'MINIMAX_M2_7',
  'MINIMAX_M2_7_HIGHSPEED',
  'MINIMAX_M2_5',
  'MINIMAX_M2_5_HIGHSPEED',
  'MINIMAX_M2_1',
  'MINIMAX_M2_1_HIGHSPEED',
  'MINIMAX_M2',
];

export const modelMapping = {
  GPT_6_ASTRA: 'gpt-6-astra',
  GPT_6_1_SOL: 'gpt-6.1-sol',
  GPT_6_1_TERRA: 'gpt-6.1-terra',
  GPT_6_SOL: 'gpt-6-sol',
  GPT_6_LUNA: 'gpt-6-luna',
  GPT_5_6_SOL: 'gpt-5.6-sol',
  GPT_5_6_TERRA: 'gpt-5.6-terra',
  GPT_5_6_LUNA: 'gpt-5.6-luna',
  GPT_5_5_PRO: 'gpt-5.5-pro',
  GPT_5_5: 'gpt-5.5',
  GPT_5_4_PRO: 'gpt-5.4-pro',
  GPT_5_4: 'gpt-5.4',
  GPT_5_4_MINI: 'gpt-5.4-mini',
  GPT_5_4_NANO: 'gpt-5.4-nano',
  GPT_5_2_PRO: 'gpt-5.2-pro',
  GPT_5_2: 'gpt-5.2',
  GPT_5_1: 'gpt-5.1',
  GPT_5_PRO: 'gpt-5-pro',
  GPT_5_MINI: 'gpt-5-mini',
  GPT_5_NANO: 'gpt-5-nano',
  GPT_5: 'gpt-5-2025-08-07',
  GPT_4_1_MINI: 'gpt-4.1-mini',
  GPT_O_4_MINI: 'o4-mini',
  GPT_4_O_MINI: 'gpt-4o-mini',
  GPT_O_3: 'o3',
  SONAR_PRO: 'sonar-pro',
  SONAR_REASONING_PRO: 'sonar-reasoning-pro',
  SONAR_DEEP_RESEARCH: 'sonar-deep-research',
  SONAR: 'sonar',
  N8N: 'n8n',
  QWEN3_6_27B: 'qwen3.6:27b',
  DEEPSEEK_R1_32B: 'deepseek-r1:32b',
  LLAMA3_LATEST: 'llama3:latest',
  GEMMA4_26B: 'gemma4:26b',
  QWEN2_5_CODER_14B_INSTRUCT: 'qwen2.5-coder:14b-instruct',
  GEMMA3_27B: 'gemma3:27b',
  CLAUDE_SONNET_4_6: 'claude-sonnet-4-6',
  CLAUDE_SONNET_4_5: 'claude-sonnet-4-5',
  CLAUDE_HAIKU_4_5: 'claude-haiku-4-5-20251001',
  CLAUDE_OPUS_4_8: 'claude-opus-4-8',
  MINIMAX_M3: 'MiniMax-M3',
  MINIMAX_M2_7: 'MiniMax-M2.7',
  MINIMAX_M2_7_HIGHSPEED: 'MiniMax-M2.7-highspeed',
  MINIMAX_M2_5: 'MiniMax-M2.5',
  MINIMAX_M2_5_HIGHSPEED: 'MiniMax-M2.5-highspeed',
  MINIMAX_M2_1: 'MiniMax-M2.1',
  MINIMAX_M2_1_HIGHSPEED: 'MiniMax-M2.1-highspeed',
  MINIMAX_M2: 'MiniMax-M2',
};
